module.exports = __webpack_public_path__ + "static/media/Mix_hover.45ad8adc.svg";